import { customApiPrefix } from "./../../templates/apis/custom";
function isCustom(id) {
  return String(id).startsWith(customApiPrefix);
}
export function getActionSchema() {
  const actions = this.getSupportedActions().reduce((prev, name) => {
    prev[name] = true;
    return prev;
  }, {});
  const {
    stateMeta: actionMeta
  } = this;
  const actionSchemas = Object.entries(actionMeta.actionInfos).map(([_, actionInfo]) => {
    const {
      defineArgs,
      schema
    } = actionInfo.def;
    if (typeof defineArgs === 'function') {
      try {
        schema.actionArguments = defineArgs(this);
      } catch (error) {
        console.error(`defineArgs fail:${schema.id}`, error);
      }
    }
    return schema;
  }).filter(item => actions[item.id]);
  const sysActions = actionSchemas.filter(item => !isCustom(item.id));
  const customActions = actionSchemas.filter(item => isCustom(item.id));
  return {
    title: '支持的action',
    type: 'object',
    fields: [...sysActions, ...customActions]
  };
}
//# sourceMappingURL=getActionSchema.js.map
